export default __webpack_public_path__ + "static/media/arrows.png?d97df887";